import actions from './actions'
import mutations from './mutation'

const state = {
  user_system_list: [],
  user_system_paging: {
    offset: 0,
    limit: 10,
    total: 0
  },
  role_list: [],
  role_paging: {
    offset: 0,
    limit: 10,
    total: 0
  }
}

export default {
  state,
  actions,
  mutations
}
